import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles } from '@/js/libs/use-auth';

import { Compliance } from 'src/scenes/Compliance/index.ts';
import Status from 'src/scenes/Status/index.ts';

const index = true;

export const complianceRouteObject = inferRouteObject({
  path: 'compliance',
  element: <PrivateRoute roles={Roles.ACCESS_COMPLIANCE} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: Compliance.Helmet,
      children: [
        {
          Component: Compliance.Layout,
          children: [
            { path: 'list-price-changes', Component: Compliance.ListPriceChanges },
            { path: 'position-financials', Component: Compliance.PositionFinancials },
            { path: 'account-financials', Component: Compliance.AccountFinancials },
            { path: 'credit-notes', Component: Compliance.CreditNotes },
            { index, path: '*', element: <Navigate to='/compliance/list-price-changes' /> },
          ],
        },
      ],
    },
  ],
});
